<template lang="pug">
fragment
  dt.required
    | 映像制作の経験
  dd
    div
      validation-provider(rules="required" name="映像制作の経験" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(vpe, i) in videoProductionExperience")
            input(type="radio" v-model="video_production_experience" :value="vpe" :id="`videoProductionExperience-${i}`")
            label(:for="`videoProductionExperience-${i}`")
              | {{ vpe }}
  FormTextInput(:rules="{ required: true }", name="現在の職種" title="現在の職種" label="video_production_years" v-model="current_job_category" type="text" placeholder="例）カメラマン")
</template>

<script>
import { Fragment } from 'vue-fragment'
import FormTextInput from '~/components/FormTextInput'
import FormTextarea from '~/components/FormTextarea'

const VIDEO_PRODUCTION_EXPERIENCE = [
  '半年未満',
  '半年以上１年未満',
  '１年以上３年未満',
  '３年以上５年未満',
  '５年以上１０年未満',
  '１０年以上'
]

export default {
  components: {
    FormTextInput,
    FormTextarea,
    Fragment
  },
  data() {
    return {
      video_production_experience: null,
      current_job_category: null,
      enquete: this.$cookies.get('entryEventEnquete') || {}
    }
  },
  computed: {
    videoProductionExperience() {
      return VIDEO_PRODUCTION_EXPERIENCE
    }
  },
  watch: {
    video_production_experience(value) {
      this.enquete.video_production_experience = value
      this.$cookies.set('entryEventEnquete', this.enquete)
    },
    current_job_category(value) {
      this.enquete.current_job_category = value
      this.$cookies.set('entryEventEnquete', this.enquete)
    }
  },
  mounted() {
    // デフォルトセット
    this.video_production_experience = this.enquete?.video_production_experience
    this.current_job_category = this.enquete?.current_job_category
  }
}
</script>
